import { Navigate, useSearchParams } from 'react-router';

import { intranetSearchRedirectTarget } from '@/products/intranet/intranet-paths';

/** `/intranet/suche` keeps `q` and lands on the feed search field. */
export function LegacySearchRedirect() {
  const [params] = useSearchParams();
  return <Navigate to={intranetSearchRedirectTarget(params.get('q'))} replace />;
}
